<div *ngIf="error">
  {{ error }}
</div>
<form [formGroup]="form"
  (submit)="onSubmit()">
  <div class="input-group">
    <mat-slide-toggle formControlName="enabled">Community Active</mat-slide-toggle>
  </div>
  <div class="input-group"
    formGroupName="settings">
    <p>

      <mat-slide-toggle formControlName="allowMemoImages">Allow images to be added to messages</mat-slide-toggle>
    </p>
  </div>
  <div class="input-group">
    <button [disabled]="loading"
      role="button"
      color="primary"
      mat-flat-button>Save</button>
  </div>
</form>